/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-underscore-dangle */
import React, {
  useState, useRef, useContext, useEffect, memo,
} from 'react';
import PropTypes from 'prop-types';

import { withTranslation } from 'language/i18n';
import maskAmount from 'utils/maskAmount';
import { TextInput, Form, Button } from 'components/common';
import { makeCounterOffer } from 'models/marketplace';
import { StatusContext } from 'contexts/statusContext';

const OfferSide = ({
  t, setVisible, setHowToAuctionWorkModalVisible, counterOfferData, setCounterOfferData, setCounterOfferPlacedResponse, counterOfferPlacedResponse,
}) => {
  const { setErrorState } = useContext(StatusContext);

  const [amount, setAmount] = useState('');
  const [unmaskedAmount, setUnmaskedAmount] = useState('');
  const [header, setHeader] = useState();
  const [formRef, setFormRef] = useState(useRef());
  const [controlButton, setControlButton] = useState(false);
  const handleAmount = ({ value }) => {
    const fixedInput = value.replace(/[^0-9]/g, '');

    const maskedAmountValue = maskAmount(fixedInput, 'EUR', true);

    formRef.setFieldsValue({
      amount: maskedAmountValue,
    });

    setAmount(maskedAmountValue);
    setUnmaskedAmount(fixedInput);
  };

  useEffect(() => {
    if (counterOfferPlacedResponse?.success) {
      setVisible(false);
      setCounterOfferData({});
      setCounterOfferPlacedResponse();
      setTimeout(() => {
        setErrorState({
          title: t('successful'),
          text: 'Karşı teklfiniz alınmıştır.',
          buttonText: t('close'),
          type: 'success',
          onClickButton: () => setErrorState({}),
        });
      }, 1000);
    }

    if (counterOfferPlacedResponse?.error) {
      setVisible(false);
      setCounterOfferData({});
      setCounterOfferPlacedResponse();
      setTimeout(() => {
        setErrorState({
          title: t('error'),
          text: counterOfferPlacedResponse?.error?.message,
          buttonText: t('close'),
          type: 'error',
          onClickButton: () => setErrorState({}),
        });
      }, 1000);
    }
  }, [counterOfferPlacedResponse]);

  const makeCounterOfferWithApi = async () => {
    try {
      if (unmaskedAmount > counterOfferData.maxOffer) {
        setControlButton(true);
        await makeCounterOffer(counterOfferData.lastOfferId, counterOfferData._id, unmaskedAmount);
      } else {
        setHeader({
          title: 'Teklifiniz onaylanmadı!',
          subtitle: 'Teklifiniz, verilen tekliften düşük.',
        });
      }
    } catch (error) {
      console.log('makeCounterOfferErr', error);
      setHeader({
        title: 'Teklifiniz onaylanmadı!',
        subtitle: error.message,
      });
    }
  };

  return (
    <div className="col-15 col-sm">
      <div className="im-box im-box--white im-box--border-radius im-box--mh-100">
        {
          header
         && (
           <div>
             <div className="fs-18 text-red1 mb-3 text-center fw-900">{header?.title}</div>
             <div className="fs-14 text-red1 mb-3 text-center">{header?.subtitle}</div>
           </div>
         )
        }
        <div className="text-center mt-5 mb-5 lh-1p4">
          <div className="fs-14">{`${maskAmount(counterOfferData.userLastOffer)} teklifiniz satıcı tarafından değerlendirilmiş ve teklifinize satıcı tarafından karşı teklif verilmiştir.`}</div>
          <div className="fs-14 fw-900">{`Satıcı tarafından verilen karşı teklif ${maskAmount(counterOfferData.offer)}'dir. Satıcının verdiği teklifi kabul edebilir ya da karşı teklif verebilirsiniz.`}</div>
        </div>

        <Form
          layout="horizontal"
          onFinish={makeCounterOfferWithApi}
          formRef={(ref) => setFormRef(ref)}
        >
          <div className="row">
            <div className="col-15 mb-2">
              <div className="im-input im-input--type2 im-input--prefix">
                <div className="im-input__prefix">€</div>
                <TextInput
                  name="amount"
                  placeholder="Lütfen teklif tutarınızı giriniz."
                  value={amount}
                  onChange={handleAmount}
                  formRef={formRef}
                  style={{ fontSize: 18, width: '100%' }}
                  hideLabel
                  formItemStyle={{
                    marginBottom: '0',
                    width: '100%',
                  }}
                />
              </div>
            </div>
            <div className="col-15">
              <Button
                disabled={controlButton}
                htmlType="submit"
                className="im-button im-button--primary im-button--size-60 im-button--center im-button--fluid fw-900"
                label="Karşı Teklif Yap"
              />
            </div>
            <div className="col-15 mt-3 text-center">
              <span className="fs-12 fw-500 text-gray3">
                Teklifiniz bir sonraki sayfada
                {' '}
                <span className="fw-900">onaylanacaktır.</span>
              </span>
            </div>
          </div>
        </Form>

        <div className="row mt-5 mb-3">
          <div className="col">
            <a
              className="d-flex align-items-center justify-content-center"
              onClick={() => {
                setVisible(false);
                setTimeout(() => {
                  setHowToAuctionWorkModalVisible(true);
                }, 500);
              }}
            >
              <span className="fs-13 fw-400 d-inline-block">{t('howBiddingWorks')}</span>
              <i className="fa-solid fa-question-circle ml-2" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

OfferSide.propTypes = {
  t: PropTypes.func,
  setVisible: PropTypes.func,
  counterOfferData: PropTypes.object,
  setHowToAuctionWorkModalVisible: PropTypes.func,
  setCounterOfferData: PropTypes.object,
  setCounterOfferPlacedResponse: PropTypes.func,
  counterOfferPlacedResponse: PropTypes.object,
};

export default withTranslation('common')(memo(OfferSide));
